import { CSSProperties, FC } from 'react';
import { Page } from 'react-pdf';

import { COLORS } from '@/shared/constants/colors';

type PageItemProps = {
  index: number;
  style: CSSProperties;
  data: {
    width: number;
    setActivePage: (n: number) => void;
    onRenderSuccess: () => void;
  };
};

export const PageItem: FC<PageItemProps> = ({ index, style, data }) => {
  return (
    <div style={{ ...style, background: COLORS.colorFilePreviewBg, overflow: 'clip' }}>
      <Page
        devicePixelRatio={2}
        onRenderSuccess={data.onRenderSuccess}
        onMouseEnter={() => data.setActivePage(index)}
        onTouchStart={() => data.setActivePage(index)}
        canvasBackground={COLORS.white}
        pageIndex={index}
        width={data.width}
      />
    </div>
  );
};
